import React from 'react';

export default class Page5 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToMakeEthicalDecisions');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now that you have considered the information in this tool and
                                                tried out some of the practical
                                                exercises around making ethical decisions, here are a number
                                                of next steps to embed the learning:</p>
                                            <div className="border_subtitle">Gain feedback</div>
                                            <p>Present your decision making rationale to a colleague or
                                                trusted advisor and ask for feedback.
                                                Ask that person(s) to be honest and open and review your
                                                decision against the bad choice
                                                detectors. Are there any flaws and/or different
                                                opportunities they can identify for you to
                                                incorporate in your decision making?</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about the opportunities that you have in your current
                                                work, or beyond, where you can
                                                practise making an ethical decision. Look at your next
                                                decision and how you go about thinking
                                                ethically. Consider how you can approach the decision, what
                                                are the broader implications of your
                                                choices, who could be most impacted by the decision? Think
                                                about the bad choice detectors
                                                when you are making your decision.</p>
                                            <div className="border_subtitle">Talk to your role model</div>
                                            <p>Identify someone who you think always behaves ethically and
                                                ask them how they go about making
                                                decisions. They may be able to provide you with some advice
                                                that can help you to be more effective.</p>
                                            <div className="border_subtitle">Use the guide ethical decisions
                                                next time you make a decision
                                            </div>
                                            <p>This guide should provide you with a framework to help you to
                                                make an ethical decision. Try this
                                                approach and see how it works for you.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Try forming an objective around making ethical decisions and
                                                factor this into your personal
                                                development plan, or create one using this as a starting
                                                point. Ensure that you give yourself clear
                                                objectives and tangible actions that will help you to
                                                progress and make a real improvement.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Further Information
                                            </div>
                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeTimelyDecisions')}>How
                                                        to make timely decisions</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}>How
                                                        to focus on the bigger picture </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}>How
                                                        to balance risk with potential benefits </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToFormulateActionPlans')}>How
                                                        to formulate action plans. </div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>


                                            <ol className="testclass">
                                                <li><p className="further_info_content">Cullen, J.,
                                                    Parboteeah, K. &amp; Hoegl, M. (2004). Cross-national
                                                    differences in managers’ willingness to justify
                                                    ethically suspect behaviours: A test of institutional
                                                    anomie theory.<span className="subtiltereg"> Academy of Management Journal,</span> 47,
                                                    41-21.</p></li>
                                                <li><p className="further_info_content">Rogerson, M. D.,
                                                    Gottlieb, M. C., Handelsman, M. M., Knapp,
                                                    S. &amp; Younggren, J. (2011).
                                                    Nonrational processes in ethical decision making. <span
                                                        className="subtiltereg">American Psychologist,</span> 66(7),
                                                    614.</p></li>
                                                <li><p className="further_info_content">Messick, D.
                                                    M. &amp; Bazerman, M. H. (1996). Ethical leadership and
                                                    the psychology of decision making.
                                                    <span
                                                        className="subtiltereg">Sloan Management Review,</span> 37,
                                                    9-22.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}